<template lang="">
  <div class="flex-fill">
    <section id="banner" class="" style="background-image: url('static/img/default/banner-new.png'); background-size: contain; background-repeat: no-repeat; background-position: top right; ">
      <div class="container py-20">
        <div class="text-center">
          <span class="d-block text-white font-size-h2 font-weight-bolder mb-10">Sampaikan Kritik & Saran untuk SEKAR HK</span>
        </div>
        <div class="card card-custom rounded-xl">
          <div class="card-body p-15">
            <h1 class="font-weight-boldest text-secondary mb-10">Form Kritik & Saran</h1>
            <div>
              <s-input :disabled="isAnonymouse" v-model="forms.name" :item="{ label: 'Nama Anda', type: 'text', validation: [], ic: 'form-control-lg', nm: true }" />
              <div class="d-flex align-items-center mt-2 mb-10">
                <div>
                  <span class="switch switch-outline switch-icon switch-sm switch-secondary">
                    <label>
                      <input v-model="isAnonymouse" type="checkbox" checked="checked" name="select" />
                      <span></span>
                    </label>
                  </span>
                </div>
                <span class="text-secondary ml-3">Sampaikan Sebagai Anonymous</span>
              </div>
              <s-input v-model="forms.contact" :item="{ label: 'Nomor / Email yang dapat dihubungi', type: 'text', validation: [], ic: 'form-control-lg', nm: false }" />
              <div class="form-group">
                <label>
                  Tipe
                  <span class="text-danger">*</span>
                </label>
                <div class="radio-inline ml-3">
                  <label class="radio radio-secondary radio-outline radio-outline-2x radio-lg font-weight-bold">
                    <input v-model="forms.type" value="feedback" type="radio" name="radios3_1" />
                    <span></span>
                    Kritik
                  </label>
                  <label class="radio radio-secondary radio-outline radio-outline-2x radio-lg font-weight-bold">
                    <input v-model="forms.type" value="suggestion" type="radio" name="radios3_1" />
                    <span></span>
                    Saran
                  </label>
                </div>
                <!-- <span class="form-text text-muted">Some help text goes here</span> -->
              </div>
              <s-input v-model="forms.category_id" :item="{ label: 'Pilih Kategori', type: 'select', validation: ['required'], ic: '', api: 'no-auth/feedback-categories', pointer: { label: 'name', code: 'id' } }" />
              <s-input v-model="forms.description" :item="{ label: 'Deskripsi', type: 'textarea',validation: ['required'], ic: 'form-control-lg', placeholder: 'Masukkan deskripsi kritik / saran' }" />
              <s-input v-if="forms.type === 'feedback'" v-model="forms.suggestion" :item="{ label: 'Usulan', type: 'textarea', validation: ['required'], ic: 'form-control-lg', placeholder: 'Masukkan saran anda' }" />
              <div class="form-group">
                <label>Lampirkan Dokumen (jika ada)</label>
                <multi-upload :error="[]" :auth="false" v-model="forms.child_data_feedback_attachments" :attr="[{ accept: '.jpg, .jpeg, .png, .pdf' }, { limit: 5 }, { max: 5 }]" />
              </div>
              <div id="g-recaptcha" class="mb-5"></div>
              <button @click="sendFeedback()" :disabled="!captcha || !validForm" class="btn btn-primary btn-lg">
                <i class="ri-mail-send-line"></i>
                <span class="font-size-md font-weight-bolder">Kirim Laporan</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: 'landing-kritik-saran',
  data () {
    return {
      forms: {
        category_id: null,
        contact: null,
        description: null,
        name: null,
        suggestion: null,
        type: 'feedback', // feedback || suggestion
        child_data_feedback_attachments: []
      },
      captcha: null,
      isErr: null,
      isAnonymouse: false
    }
  },
  watch: {
    isAnonymouse: {
      deep: false,
      immediate: false,
      handler (e) {
        if (e) {
          this.$set(this.forms, 'name', 'Anonymous')
        } else {
          this.$set(this.forms, 'name', this.$store.state.profile ? this.$store.state.profile.fullname : null)
        }
      }
    }
  },
  computed: {
    validForm () {
      if (this.forms.type === 'feedback') {
        return Boolean(this.forms.category_id && this.forms.contact && this.forms.type && this.forms.suggestion)
      } else {
        return Boolean(this.forms.category_id && this.forms.contact && this.forms.type)
      }
    }
  },
  mounted () {
    // <!-- 6LeLrgYlAAAAAGfHpG5y7_j4uB10T2r3-0O3CGn_ -->
    // eslint-disable-next-line no-undef
    grecaptcha.render('g-recaptcha', {
      sitekey: '6LcmigopAAAAAOOR7S4E4APu-02vaLdi5l1SGcQo',
      callback: ($event) => {
        this.captcha = $event
      },
      'expired-callback': ($event) => {
        this.captcha = null
      },
      'error-callback': ($event) => {
        this.captcha = null
      }
    })
    if (this.$store.state.profile) this.$set(this.forms, 'name', this.$store.state.profile.fullname)
  },
  methods: {
    sendFeedback () {
      if (this.validForm) {
        if (this.isAnonymouse) this.forms.name = 'Anonymous'
        this.$_api
          .create('no-auth/feedback-suggestions', this.forms)
          .then((res) => {
            this.$_alert.success('Kritik & Saran Anda berhasil dikirim')
            this.forms = Object.assign({}, {
              category_id: null,
              contact: null,
              description: null,
              // name: null,
              suggestion: null,
              type: 'feedback', // feedback || suggestion
              child_data_feedback_attachments: []
            })
            this.isAnonymouse = false
            window.scrollTo(0, 0)
          })
          .catch((err) => {
            this.$_alert.error(err)
          })
      }
    }
  }
}
</script>
<style lang=""></style>



// WEBPACK FOOTER //
// src/landing-page/kritik-saran.vue